<template>
  <v-container>
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <v-flex v-if="documents.length > 0">
      <v-list
        subheader
        two-line
      >
        <v-subheader inset>
          {{ $t('custom.files') }}
        </v-subheader>

        <v-list-item
          v-for="document in documents"
          :key="document.id"
        >
          <v-list-item-avatar>
            <v-icon
              class="grey lighten-1"
              dark
            >
              mdi-folder
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <!-- <v-list-item-title v-text="document.name"></v-list-item-title> -->

            <v-list-item-subtitle>
              {{ fileName(document.name) }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action>
            <v-flex>
              <v-icon class="mx-1" color="info" @click="downloadItem(document)">
                mdi-content-save-outline
              </v-icon>
              <v-icon
                class="mx-1"
                color="warning"
                @click="deleteItem(document)"
              >
                mdi-delete-forever
              </v-icon>
            </v-flex>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-flex>
    <v-flex v-else class="d-flex text-center justify-center">
      <v-card flat tile class="d-flex text-center justify-center">
        {{ $t('other.no_docs') }}
      </v-card>
    </v-flex>
  </v-container>
</template>
<script>
import { saveAs } from "file-saver";
import { Capacitor } from "@capacitor/core";
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';
export default {
  data() {
    return {
      documents: [],
      gallery_items: [],
      link_full_image: "",
      dialog: false,
      isLoading: false
    };
  },
  beforeCreate() {
    this.isLoading = true;
    this.axios
      .get(`/api/v1/contractor_files/${this.$route.params.id}`, {
        headers: {
          Authorization: this.$store.getters.getAuthToken
        }
      })
      .then(response => {
        this.documents = response.data;
      })
      .catch(error => {
        this.setError(error, this.$t('errors.file_links_load'));
        console.log(error);
      })
      .finally(() => (this.isLoading = false));
  },
  computed: {
    isNative() {
      return Capacitor.isNativePlatform();
    },
    checkWriteFile() {
      return Capacitor.isNativePlatform() && Filesystem.checkPermissions();
    },
    requestPermissionsWriteFile() {
      return Filesystem.requestPermissions();
    },
  },
  methods: {
    fileName(name) {
      return name.split("/").pop();
    },
    screenFullImage(item) {
      this.link_full_image = item.url;
      this.dialog = true;
    },
    downloadItem(item) {
      if (!this.isNative) {
        saveAs(`${item.url}`);
      } else {
        this.downloadFileToMobile(item.url);
      }
    },
    downloadFileToMobile(item_url) {
      if (Filesystem.checkPermissions()) {
        // Сначала получаем Blob из URL
        fetch(item_url)
          .then(response => response.blob())
          .then(blob => {
            // Теперь у нас есть настоящий Blob объект
            const getBase64FromBlob = async (blob) => {
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                  const base64data = reader.result;
                  resolve(base64data);
                }
              });
            }

            return getBase64FromBlob(blob);
          })
          .then((base64) => {
            // Определяем расширение файла
            let fileExtension = '';

            // Пытаемся получить расширение из URL
            const urlExtMatch = item_url.match(/\.([^./?#]+)($|\?|#)/);
            if (urlExtMatch) {
              fileExtension = `.${urlExtMatch[1].toLowerCase()}`;
            }
            // Если не удалось получить из URL, пытаемся определить из MIME-типа в base64
            else if (base64.startsWith('data:')) {
              const mimeMatch = base64.match(/^data:([^;]+);/);
              if (mimeMatch) {
                const mimeType = mimeMatch[1].toLowerCase();
                if (mimeType.startsWith('image/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType === 'application/pdf') {
                  fileExtension = '.pdf';
                } else if (mimeType.startsWith('video/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                } else if (mimeType.startsWith('audio/')) {
                  fileExtension = `.${mimeType.split('/')[1]}`;
                }
              }
            }

            // save file
            async function writeFile() {
              return await Filesystem.writeFile({
                path: `photo_${Date.now()}_${Math.floor(Math.random() * 1000)}${fileExtension}`,
                data: base64,
                directory: Directory.Documents,
              });
            }

            writeFile().then((getUriResult) => {
              // share file opened file
              let shareFile = async () => {
                await Share.share({
                  title: 'Download document',
                  files: [getUriResult.uri],
                }).catch((error) => {
                  console.log("shareFile", error)
                });
              };

              shareFile();
            }).catch((error) => {
              console.log("shareFile", error)
            });
          })
          .catch(error => {
            console.log("Error getting base64:", error);
          });
      } else {
        Filesystem.requestPermissions();
      }
    },
    async deleteItem(item) {
       if (this.isStaff) {
        let self = this
        this.$confirm({
          title: this.$t('custom.you_sure_title'),
          text: this.$t('custom.you_sure_text'),
          icon: "mdi-alert-circle-outline",
          confirmButtonText: this.$t('custom.you_sure_yes'),
          cancelButtonText: this.$t('custom.you_sure_no'),
        }).then(result => {
          if (result) {
            this.isLoading = true;
            this.axios
              .delete(`/api/v1/contractor_files/${item.id}`, {
                headers: {
                  Authorization: self.$store.getters.getAuthToken
                }
              })
              .then(() => {
                this.documents.splice(this.documents.indexOf(item), 1);
                this.$notify(this.$t('custom.deleted'), this.$t('other.delete_file'), "success", 2000);
              })
              .catch(error => {
                this.setError(error, this.$t('errors.file_client_load'));
              })
              .finally(() => (this.isLoading = false));
          }
        });
      } else {
        this.$notify(this.$t("errors.no_access"), "", "warning");
      }
    }
  }
};
</script>
